import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FormWrapper, SubmitButton } from "..";
import { validMapsUrls } from "../../constants";
import ModalWrapper from "./Modal";

function LinkUploadModal({ handleClose, isVisible, handleSave, data, linkType, invalidMessage }) {
  const [link, setLink] = useState("");
  const [showError, setShowError] = useState(false);
  const [allowedLinks, setAllowedLinks] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!linkType) return;
    if (linkType === "google_maps_url") {
      setAllowedLinks(validMapsUrls);
    }
  }, [linkType]);

  const handleSaveLink = async (e) => {
    e.preventDefault();
    if (!link) {
      setErrorMessage("Please add a link");
      setShowError(true);
      return;
    }

    if (link.length > 200) {
      setErrorMessage("Maximum limit for url length is 200 characters");
      setShowError(true);
      return;
    }

    if (allowedLinks.length > 0 && !allowedLinks.some((allowedLink) => link.includes(allowedLink))) {
      setErrorMessage(invalidMessage);
      setShowError(true);
      // toast.error(invalidMessage);
      return;
    }

    handleSave(link);
    return;
  };

  useEffect(() => {
    if (data) setLink(data);
  }, [data]);

  return (
    <ModalWrapper isVisible={isVisible} onClose={handleClose} name={"link_upload_modal"} level={2} fit>
      <FormWrapper id="link_upload_form" title="Link Upload" onSubmit={handleSaveLink}>
        <div className="input_wrapper full">
          <input
            type="url"
            placeholder="Enter link"
            className="input"
            onChange={(e) => setLink(e.target.value)}
            required
            value={link}
            // maxLength={150}
          />
          <span className="error small">{showError ? errorMessage : ""}</span>
        </div>
        <SubmitButton isUpload form="link_upload_form" center>
          Upload
        </SubmitButton>
      </FormWrapper>
    </ModalWrapper>
  );
}

export default LinkUploadModal;
